
/*
*   申请页面的tab数组
* */
export const launch_arr = [
    {name: '申请中', id: '1'},
    {name: '已安排', id: '2'},
    {name: '已取消', id: '3'}
]

/*
*   安排页面的tab数组
* */
export const accept_arr = [
    {name: '待处理', id: '1'},
    {name: '已安排', id: '2'},
    {name: '已取消', id: '3'}
]

/***
 *  远程会诊界面的tab数组
 */
export  const dis_arr = [
    {name: '待就诊', id: 1},
    {name: '已就诊', id: 2},
    {name: '已取消', id: 3}
]


/**
 *  获取当天时间和一年前的当天时间
 * */
export const getOneYearTime = function(){
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const year = date.getFullYear();
    const month = date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return {start:(year-1) + '-' + month + '-' + day,end:year + '-' + month + '-' + day}
}

/**
 *  获取当天时间和一个月前的当天时间
 * */
export const getOneMonTime = function(){
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const year = date.getFullYear();
    const month = date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

    const date2 = new Date();
    date2.setMonth(date2.getMonth()-1);
    date2.setHours(0);
    date2.setMinutes(0);
    date2.setSeconds(0);
    date2.setMilliseconds(0);
    const year2 = date2.getFullYear();
    const month2 = date2.getMonth()+1 < 10 ? '0' + (date2.getMonth()+1) : (date2.getMonth()+1);
    const day2 = date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate();

    return {start:year2 + '-' + month2 + '-' + day2,end:year + '-' + month + '-' + day}
}

/**
 *  获取当天时间和前几日
 * */
export const getLastTime = function(num){
    const date = new Date();
    const lastDate = new Date();
    lastDate.setDate(date.getDate() + num);
    lastDate.setHours(0);
    lastDate.setMinutes(0);
    lastDate.setSeconds(0);
    lastDate.setMilliseconds(0);
    date.setDate(date.getDate() - num);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const year = date.getFullYear();
    const month = date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const lastYear = lastDate.getFullYear();
    const lastMonth = lastDate.getMonth()+1 < 10 ? '0' + (lastDate.getMonth()+1) : (lastDate.getMonth()+1);
    const lastDay = lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate();

    return {start:lastYear + '-' + lastMonth + '-' + lastDay,end:year + '-' + month + '-' + day}
}



/***
 *  格式化时间
 */
export const timeFormat = (time, str) => {
    const handlerZero = (value) => {
        return value < 10 ? '0' + value : value;
    };
    const dateObj = new Date(time);
    const Y = dateObj.getFullYear();
    const m = handlerZero(dateObj.getMonth() + 1);
    const d = handlerZero(dateObj.getDate());
    const W = dateObj.getDay();
    const H = handlerZero(dateObj.getHours());
    const M = handlerZero(dateObj.getMinutes());
    const S = handlerZero(dateObj.getSeconds());

    const ruleArr = [
        {regx: new RegExp('%' + 'Y', 'g'), value: Y},
        {regx: new RegExp('%' + 'm', 'g'), value: m},
        {regx: new RegExp('%' + 'd', 'g'), value: d},
        {regx: new RegExp('%' + 'H', 'g'), value: H},
        {regx: new RegExp('%' + 'M', 'g'), value: M},
        {regx: new RegExp('%' + 'S', 'g'), value: S},
        {regx: new RegExp('%' + 'W', 'g'), value: ['日', '一', '二', '三', '四', '五', '六'][W]}
    ];

    ruleArr.forEach(r => {
        str = str.replace(r.regx, r.value);
    });

    return str;
};
/***
 *  患者信息表单校验规则
 *
 */
export const patineInfoRules = {
    patName: [
        { required: true, message: '请输入患者姓名', trigger: 'blur' }
    ],
    patIdcard: [
        { required: true, message: '请输入患者身份证号码', trigger: 'blur' }
    ],
    patMobile: [
        { required: true, message: '请正确输入患者电话号码', trigger: 'blur' },
        { pattern: /^1[34578]\d{9}$/, message: '手机号码格式错误', trigger: 'blur'  }
    ],
    patJob:[
        { required: false, message: '职业名称长度过长', trigger: 'blur' },
        { pattern: /^.{1,20}$/, message: '职业名称长度过长', trigger: 'blur'  }
    ],
    province: [
        { required: true, message: '请选择家庭地址', trigger: ['change','blur'] }
    ],
    address:[
        { required: true, message: '请填写家庭地址', trigger: 'blur' }
    ],

    consulterName: [
        { required: true, message: '请输入患者姓名', trigger: 'blur' }
    ],
    consulterIdcard: [
        { required: true, message: '请输入患者身份证号码', trigger: 'blur' }
    ],
    consulterMobile: [
        { required: true, message: '请正确输入患者电话号码', trigger: 'blur' },
        { pattern: /^1[34578]\d{9}$/, message: '手机号码格式错误', trigger: 'blur'  }
    ],
    consulterAddress:[
        { required: true, message: '请填写家庭地址', trigger: 'blur' }
    ],
    consulterJob:[
        { required: false, message: '职业名称长度过长', trigger: 'blur' },
        { pattern: /^.{1,20}$/, message: '职业名称长度过长', trigger: 'blur'  }
    ]

}

/**
 * 病情描述的规则
 *
 * */
export  const diseaseRule ={
    tentativeDiagnosis: [
        { required: true, message: '请输入初步诊断', trigger: 'blur' }
    ],
    consultContent:[
        { required: true, message: '请输入主述', trigger: 'blur' }
    ],
    beforeDiagnose: [
        { required: true, message: '请输入初步诊断', trigger: 'blur' }
    ],
    consultReason :[
        { required: true, message: '请输入申请会诊目的或者事由', trigger: 'blur' }
    ]
}

/**
 *  申请方信息规则
 * */
export const docInfoRule = {
    hosCode: [
        { required: true, message: '请选择医院', trigger: 'change' }
    ],
    depCode: [
        { required: true, message: '请选择科室', trigger: 'change' }
    ],
    initDocId: [
        { required: true, message: '请选择医生', trigger: 'change' }
    ],
    applyHosId: [
        { required: true, message: '请选择医院', trigger: 'change' }
    ],
    applyDeptId: [
        { required: true, message: '请选择科室', trigger: 'change' }
    ],
    applyDocId: [
        { required: true, message: '请选择医生', trigger: 'change' }
    ],
    consultGroupType:[
        { required: true, message: '请选择申请类型', trigger: 'change' }
    ],
    auxiliaryDiagnose:[
        { required: true, message: '请选择辅助类型', trigger: 'change' }
    ]
}

/**
 *  预约信息规则
 * */
export const appointmentInfoRule = {
    hopeHosId: [
        { required: true, message: '请选择预约医院', trigger: 'change' }
    ],
    hopeTime: [
        { required: true, message: '请选择期望转诊时间', trigger: 'change' }
    ],
    'inspectIds[0]':[
        { required: true, message: '请选择项目', trigger: 'change' }
    ],
    hopeDeptId:[
        { required: true, message: '请选择预约科室', trigger: 'change' }
    ]
}


export const fileToNase64 = function(file){
    return new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = () => {
            resolve(fr.result);
        }
        fr.onerror = (e) => {
            reject(e);
        }
    })
}


export const depKind = [
    {value:"1",label:"专家门诊"},
    {value:"2",label:"普通门诊"}
]

export const ONLINE_BTN_MAP = {
    '提醒进入诊间': {type: 'app_btn_default'},
    '接诊': {type: 'app_btn_primary'},
    '查看资料': {type: 'app_btn_default'},
    '提醒取号': {type: 'app_btn_default'}
}

export const ONLINE_DDZT_BTN = {
    '0': ['提醒进入诊间', '接诊'],
    '1': ['提醒取号'],
    '2': ['查看资料'],
    // '2': ['查看资料']
}